import React, { Fragment } from 'react';
import { Card, CardBody, Col, Row, Button } from 'reactstrap';
import { useBranches } from '../../../hooks/branches/useBranches';
import { ModalBranch } from '../../../components/branches/ModalBranch';
import { TitleDataTable } from '../../../components/tableDataTable/TitleDataTable';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

export const IndexBranch = () => {

    const {
        branches, states, municipalities, commercialLines,
        method, handleInputChange, validaciones,
        id_commercial_line, code, name, number_phone, email, id_state, id_municipality,
        address, colony, cp, url, logo, name_responsible, certificate, image_firm, toma,
        imageLogo, imageFirm, imageBackground, roleUser_responsible,
        closeDialog, modal, modalTitle, loading,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        handleChangeState,
        previewLogo, previewFirm, previewBackground, imageHandler, navigateExamsMaquila, navigateSettingsInvoice,
        handleSearchBranch, searchBranch, handleClearBranch,
        loadingExcel, handleExcelBranch
    } = useBranches();


    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };




    const actions = (rowData) => {
        const configurationBranches =
            localStorage.getItem("configurationbranches") || "";

        const blockedBranches = configurationBranches
            .split(",")
            .map(x => Number(x.trim()));

        const blockInvoiceButton = blockedBranches.includes(Number(rowData?.id_branch));


        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                <Button
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_branch)}
                    title="Editar sucursal"
                    className="btnTableAction"
                >
                    <i className="fa fa-edit iconTableAction"></i>
                </Button>

                <button
                    onClick={() => navigateExamsMaquila(rowData.id_branch)}
                    title="Estudios a maquilar"
                    className="btnTableAction"
                    style={{
                        backgroundColor: "#F44336"
                    }}
                >
                    <i className="icofont icofont-laboratory iconTableAction"></i>
                </button>

                <button
                    onClick={() => navigateSettingsInvoice(rowData.id_branch)}
                    title="Serie y folio para facturas"
                    className="btnTableAction"
                    style={{
                        backgroundColor: blockInvoiceButton
                            ? "#bdbdbd"
                            : "#9E114A",
                        cursor: blockInvoiceButton
                            ? "not-allowed"
                            : "pointer",
                        opacity: blockInvoiceButton
                            ? 0.6
                            : 1
                    }}

                    disabled={blockInvoiceButton}

                >
                    <i className="fa fa-file-pdf-o iconTableAction"></i>
                </button>
            </div>
        );
    };


    return (

        <Fragment>
            {/* <Breadcrumb parent="Dashboard" title="Listado de sucursales" /> */}
            <div className='container-global-zoom'>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody className="p-1 mt-2">
                                <TitleDataTable
                                    titleTable="Listado de sucursales"
                                    buttonActions={handleExcelBranch}
                                    titleButton="Listado de sucursales "
                                    isDisbled={loadingExcel}
                                    loadingIsDisabled={loadingExcel}
                                    titleCreate="Crear sitio"
                                    showCreateButton={false}
                                    buttonActionsCreate={handleCreate}
                                    actionInput={handleSearchBranch}
                                    valueFilter={searchBranch}
                                    filterLocalStorage={true}
                                    cleanFilterLocalStorage={handleClearBranch}
                                />


                                <div className="table-responsive">
                                    <DataTable
                                        value={branches}
                                        paginator
                                        rows={15}
                                        responsiveLayout="scroll"
                                        rowsPerPageOptions={[15, 50, 100]}
                                        className="data-table p-datatable-striped p-datatable-sm"
                                        emptyMessage={
                                            <div className="text-center">
                                                <img
                                                    src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                    style={{ width: "32%" }}
                                                    alt="Sin resultados"
                                                />
                                                <br />
                                                <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                                    No se encontraron resultados.
                                                </p>
                                            </div>
                                        }
                                    >

                                        <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                        <Column
                                            field="name"
                                            header="Sucursal"
                                            body={(rowData) => (
                                                <span style={{ fontWeight: "bold" }}>
                                                    {rowData.name}
                                                </span>
                                            )}
                                            headerStyle={headerStyle}
                                            style={cellStyle}
                                        />

                                        <Column
                                            field="name_short_commercial_line"
                                            header="Razón social"
                                            body={(rowData) => (
                                                <span>
                                                    {rowData.name_short_commercial_line}
                                                </span>
                                            )}
                                            headerStyle={headerStyle}
                                            style={cellStyle} />
                                        <Column
                                            field="rfc"
                                            header="RFC"
                                            headerStyle={headerStyle}
                                            style={cellStyle}
                                            body={(rowData) => (
                                                <span>
                                                    {rowData.rfc}
                                                </span>
                                            )}
                                        />
                                        <Column
                                            field="toma"
                                            header="Solo toma de muestra"
                                            body={(rowData) => {

                                                const isToma = rowData.toma === true || rowData.toma === 1;

                                                return (
                                                    <span
                                                        style={{
                                                            width: "50px",
                                                            textAlign: "center",
                                                            color: "#fff",
                                                            backgroundColor: isToma ? "#ff9d00" : "#1fbff0",
                                                            padding: "4px 0px",
                                                            borderRadius: "12px",
                                                            fontSize: "12px",
                                                            display: "inline-block",
                                                            fontWeight: "600",
                                                        }}
                                                    >
                                                        {isToma ? "Sí" : "No"}
                                                    </span>
                                                );
                                            }}
                                            headerStyle={headerStyle}
                                            style={cellStyle}
                                        />
                                        <Column
                                            field="status"
                                            header="Estatus"
                                            body={(rowData) => {

                                                const isIncompleto = rowData.status === "Incompleto";

                                                return (
                                                    <span
                                                        style={{
                                                            width: "90px",
                                                            textAlign: "center",
                                                            color: "#fff",
                                                            backgroundColor: isIncompleto ? "#e74c3c" : "#2ecc71",
                                                            padding: "4px 0px",
                                                            borderRadius: "12px",
                                                            fontSize: "12px",
                                                            display: "inline-block",
                                                            fontWeight: "600",
                                                        }}
                                                    >
                                                        {isIncompleto ? "Incompleto" : "Completo"}
                                                    </span>
                                                );
                                            }}
                                            headerStyle={headerStyle}
                                            style={cellStyle}
                                        />
                                        <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />
                                    </DataTable>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
            <ModalBranch
                {
                ...{
                    modal, closeDialog, modalTitle, method, loading,
                    states, municipalities, commercialLines,
                    handleInputChange, validaciones,
                    id_commercial_line, name, code, number_phone, email, id_state, id_municipality,
                    address, colony, cp, url, logo, name_responsible, certificate, image_firm, toma,
                    imageLogo, imageFirm, imageBackground,
                    saveCreate, saveDelete, saveUpdate,
                    handleChangeState,
                    previewLogo, previewFirm, previewBackground, imageHandler, roleUser_responsible
                }
                }
            />
        </Fragment>
    );
}
